const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/devices/$deviceId/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/devices/$deviceId/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { DevicesPendingState } from '@/features/calibration/components/DevicesPendingState';
import { calibrationSessionsQuery } from '@/features/calibration/services/calibrationQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/calibration/devices/$deviceId/')({
  beforeLoad: requireCapabilities(has => has('calibration.read') || has('calibration.program.read')),
  loader: ({
    context,
    params
  }) => context.queryClient.ensureInfiniteQueryData(calibrationSessionsQuery(params.deviceId)),
  pendingComponent: DevicesPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});